import {
    InformationCircleIcon,
    ClockIcon,
    ExclamationTriangleIcon,
} from "@heroicons/react/24/outline";

export default function BookCard({
    book,
    onSelect = () => { },
    onIconClick = () => { },
    selectedBook,
    detailsView,
}) {
    const isActive = selectedBook?.id === book.id;

    const iconBase = "h-5 w-5 cursor-pointer transition-colors";

    const isInfoActive = isActive && detailsView === "BOOK_SETTINGS";
    const isHistoryActive = isActive && detailsView === "BOOK_HISTORY";
    const isDamageActive = isActive && detailsView === "BOOK_DAMAGE";

    /* ---------- STOCK STATUS ---------- */
    const stock = book.stock_status || "Available";
    const isOut = stock === "outofstock";

    return (
        <div
            onClick={() => onSelect(book)}
            className={`relative flex items-start gap-3 border rounded-lg p-3 cursor-pointer transition
        ${isActive ? "bg-blue-50 border-blue-300" : "hover:bg-gray-50"}
        ${isOut ? "opacity-50" : ""}
      `}
        >
            {/* IMAGE */}
            <div className="w-16 h-24 flex-shrink-0 overflow-hidden rounded">
                <img
                    src={book.img || "https://via.placeholder.com/120x180"}
                    alt={book.title}
                    className="w-full h-full object-cover"
                />
            </div>

            {/* DETAILS */}
            <div className="flex-1 min-w-0 space-y-0.5">
                <h3 className="font-medium text-sm truncate">{book.title}</h3>

                {/* CREDITS */}
                <p className="text-xs text-blue-600">
                    {book.credits ? `${book.credits} Credit` : "—"}
                </p>

                {/* STOCK STATUS */}
                <p
                    className={`text-xs font-medium ${isOut ? "text-red-500" : "text-green-600"
                        }`}
                >
                    {isOut ? "Out of stock" : "Available"}
                </p>

                {/* BOOK ID */}
                <p className="text-[11px] text-gray-500">Book Id: {book.id}</p>

                {/* Smart ID */}
                <p className="text-[11px] text-gray-500">
                    Smart Id: {book.smart_product_id}
                </p>
            </div>

            {/* ICONS */}
            <div className="flex flex-col gap-3 text-gray-400 pt-1">
                <InformationCircleIcon
                    className={`${iconBase} ${isInfoActive ? "text-blue-600" : "hover:text-gray-700"
                        }`}
                    title="Book Information"
                    onClick={(e) => {
                        e.stopPropagation();
                        onIconClick(book, "BOOK_SETTINGS");
                    }}
                />

                <ClockIcon
                    className={`${iconBase} ${isHistoryActive ? "text-blue-600" : "hover:text-gray-700"
                        }`}
                    title="Book History"
                    onClick={(e) => {
                        e.stopPropagation();
                        onIconClick(book, "BOOK_HISTORY");
                    }}
                />

                <ExclamationTriangleIcon
                    className={`${iconBase} ${isDamageActive ? "text-red-600" : "hover:text-red-500"
                        }`}
                    title="Damage"
                    onClick={(e) => {
                        e.stopPropagation();
                        onIconClick(book, "BOOK_DAMAGE");
                    }}
                />
            </div>

            {/* ACTIVE STRIP */}
            {isActive && (
                <span className="absolute left-0 top-0 bottom-0 w-1 bg-blue-500 rounded-l" />
            )}
        </div>
    );
}
